/**
 * Collection Filter & Sort Fix
 * Ensures sort_by and collection_filter work together
 */
(function() {
  'use strict';

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionFilterSync);
  } else {
    initCollectionFilterSync();
  }

  function initCollectionFilterSync() {
    // Get all forms involved
    const sortForm = document.getElementById('FacetSortForm');
    const filterForm = document.getElementById('FacetFiltersForm');
    const mobileFilterForm = document.getElementById('FacetFiltersFormMobile');

    // Current URL parameters
    const urlParams = new URLSearchParams(window.location.search);

    // Sync collection filter change
    const collectionRadios = document.querySelectorAll('.collection-filter-radio, .collection-filter-radio-mobile');
    collectionRadios.forEach(function(radio) {
      radio.addEventListener('change', function(e) {
        e.preventDefault();
        handleCollectionChange(this);
      });
    });

    // Sync sort change
    const sortSelects = document.querySelectorAll('#SortBy-sidebar, #SortBy-mobile');
    sortSelects.forEach(function(select) {
      select.addEventListener('change', function(e) {
        e.preventDefault();
        handleSortChange(this);
      });
    });

    // Handle collection filter change
    function handleCollectionChange(radio) {
      const collectionUrl = radio.getAttribute('data-collection-url');
      const currentSort = getCurrentSort();
      const currentPriceGte = getPriceGte();
      const currentPriceLte = getPriceLte();

      if (!collectionUrl) return;

      // Build new URL
      let newUrl = collectionUrl;
      const params = [];

      if (currentSort) {
        params.push('sort_by=' + encodeURIComponent(currentSort));
      }
      if (currentPriceGte !== '') {
        params.push('filter.v.price.gte=' + encodeURIComponent(currentPriceGte));
      }
      if (currentPriceLte !== '') {
        params.push('filter.v.price.lte=' + encodeURIComponent(currentPriceLte));
      }

      if (params.length > 0) {
        newUrl += '?' + params.join('&');
      }

      // Navigate
      window.location.href = newUrl;
    }

    // Handle sort change
    function handleSortChange(select) {
      const sortValue = select.value;
      const currentCollection = getCurrentCollection();
      const currentPriceGte = getPriceGte();
      const currentPriceLte = getPriceLte();

      // Build new URL
      let baseUrl = window.location.pathname;
      const params = [];

      if (sortValue) {
        params.push('sort_by=' + encodeURIComponent(sortValue));
      }
      if (currentCollection && currentCollection !== window.location.pathname) {
        // If we have a different collection, navigate there
        baseUrl = currentCollection;
      }
      if (currentPriceGte !== '') {
        params.push('filter.v.price.gte=' + encodeURIComponent(currentPriceGte));
      }
      if (currentPriceLte !== '') {
        params.push('filter.v.price.lte=' + encodeURIComponent(currentPriceLte));
      }

      let newUrl = baseUrl;
      if (params.length > 0) {
        newUrl += '?' + params.join('&');
      }

      // Navigate
      window.location.href = newUrl;
    }

    // Get current sort value
    function getCurrentSort() {
      const sortSelect = document.getElementById('SortBy-sidebar') || document.getElementById('SortBy-mobile');
      if (sortSelect) {
        return sortSelect.value;
      }
      // Fallback to URL
      return new URLSearchParams(window.location.search).get('sort_by') || '';
    }

    // Get current collection from checked radio or URL
    function getCurrentCollection() {
      const checkedRadio = document.querySelector('.collection-filter-radio:checked, .collection-filter-radio-mobile:checked');
      if (checkedRadio) {
        return checkedRadio.getAttribute('data-collection-url');
      }
      // Check URL param
      const urlCollection = new URLSearchParams(window.location.search).get('collection_filter');
      if (urlCollection) {
        return urlCollection;
      }
      return window.location.pathname;
    }

    // Get price from value
    function getPriceGte() {
      const minInput = document.getElementById('Filter-Price-GTE') || document.getElementById('Mobile-Filter-Price-GTE');
      return minInput ? minInput.value : '';
    }

    // Get price to value
    function getPriceLte() {
      const maxInput = document.getElementById('Filter-Price-LTE') || document.getElementById('Mobile-Filter-Price-LTE');
      return maxInput ? maxInput.value : '';
    }

    // Handle price filter form submission
    if (filterForm) {
      filterForm.addEventListener('submit', function(e) {
        e.preventDefault();
        handleFilterSubmit();
      });
    }

    if (mobileFilterForm) {
      mobileFilterForm.addEventListener('submit', function(e) {
        e.preventDefault();
        handleFilterSubmit();
      });
    }

    function handleFilterSubmit() {
      const currentSort = getCurrentSort();
      const currentCollection = getCurrentCollection();
      const priceGte = getPriceGte();
      const priceLte = getPriceLte();

      let baseUrl = currentCollection || window.location.pathname;
      const params = [];

      if (currentSort) {
        params.push('sort_by=' + encodeURIComponent(currentSort));
      }
      if (priceGte !== '') {
        params.push('filter.v.price.gte=' + encodeURIComponent(priceGte));
      }
      if (priceLte !== '') {
        params.push('filter.v.price.lte=' + encodeURIComponent(priceLte));
      }

      let newUrl = baseUrl;
      if (params.length > 0) {
        newUrl += '?' + params.join('&');
      }

      window.location.href = newUrl;
    }

    // Set checked state based on URL on page load
    function syncCheckedState() {
      const urlParams = new URLSearchParams(window.location.search);
      const currentCollectionUrl = urlParams.get('collection_filter') || window.location.pathname;

      // Find and check the corresponding radio
      collectionRadios.forEach(function(radio) {
        const radioUrl = radio.getAttribute('data-collection-url');
        if (radioUrl === currentCollectionUrl || 
            (currentCollectionUrl.includes(radioUrl) && radioUrl !== '/collections/all')) {
          radio.checked = true;
        }
      });
    }

    // Run on init
    syncCheckedState();

    // Re-run on Shopify section update
    document.addEventListener('shopify:section:load', function() {
      initCollectionFilterSync();
    });
  }
})();
